// Swap this whenever you have a new announcement.
// Set enabled to false to hide the popup.
// Change id when you post a new one so it shows again for people who dismissed the last one.

module.exports = {
  enabled: true,
  id: "arc-registration",
  tag: "New",
  icon: "trophy",
  title: "ARC Registration",
  body: "Register through my GBarena link — it helps if you use this one.",
  cta: "Register now",
  url: "https://links.gbarena.com/NotRaybae",
  dismiss: "Maybe later",
};
